import {Skeleton} from "@mui/material";
import React from "react";
import "../pages.scss";
import "./meetingOverviewLoader.scss";

const MeetingOverviewLoader = () => {
    return <div className={"transparent-container loader-container"}>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
            </div>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
            </div>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
            </div>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
            </div>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
                <Skeleton animation="wave" height={20}/>
            </div>
        </div>
}

export default MeetingOverviewLoader;